import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import CNDDistrictReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/cnd-district.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(CNDDistrictReducer, defaultState, asyncActions);
};

type IDistrictContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const CNDDistrictContext = createContext<Partial<IDistrictContext>>({
  state: defaultState,
}) as React.Context<IDistrictContext>;

const CNDDistrictProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <CNDDistrictContext.Provider value={{ ...reducer }}>
      {children}
    </CNDDistrictContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useCNDDistrictContext = () => useContext(CNDDistrictContext);

export type IuseCNDDistrictContext = ReturnType<typeof useCNDDistrictContext>;

export { CNDDistrictContext, CNDDistrictProvider };
